export default "__VITE_ASSET__b3cd6484__"